/**
 * Le lot des lives (tout ce qui entoure une séance, sauf la salle) : ses routes poussées.
 *
 * Pontées par le câblage de la coquille ; une route sans entrée ici rend son écran legacy. Un écran
 * inscrit ici est chargé à son premier rendu (`loadedOnRender`). La prescription
 * (`study-mission-prescription`) et le bilan (`end-session-tutor`) sont aussi poussés dans la pile du
 * live, à la clôture : depuis que la salle est câblée, ils y vivent (`livesInLive`), comme les écrans
 * d'après la séance de l'élève (décision 3 du câblage hors live).
 */
import { loadedOnRender } from "../../student/loadedOnRender"
import { livesInLive } from "../../student/studentSpaceRouteTypes"
import { type TutorSpaceRouteTable } from "../tutorSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
export const livesRoutes: TutorSpaceRouteTable<"lives"> = {
    "tutor/lives": loadedOnRender(() => require("./TutorLivesListScreen").TutorLivesListScreen, "TutorLivesListScreen"),
    "tutor-lives-history": loadedOnRender(
        () => require("./TutorLivesHistoryScreen").TutorLivesHistoryScreen,
        "TutorLivesHistoryScreen"
    ),
    "move-session": loadedOnRender(
        () => require("./TutorManageSessionScreen").TutorManageSessionScreen,
        "TutorManageSessionScreen"
    ),
    "tutor/prepare-live": loadedOnRender(
        () => require("./TutorPrepareLiveScreen").TutorPrepareLiveScreen,
        "TutorPrepareLiveScreen"
    ),
    "study-mission-prescription": livesInLive(
        loadedOnRender(() => require("./TutorPrescriptionScreen").TutorPrescriptionScreen, "TutorPrescriptionScreen")
    ),
    "end-session-tutor": livesInLive(
        loadedOnRender(() => require("./TutorCloseOutScreen").TutorCloseOutScreen, "TutorCloseOutScreen")
    ),
}
/* eslint-enable @typescript-eslint/no-require-imports */
